import DashboardLayout from "@/components/DashboardLayout";
import { PlaygroundLayout } from "./components/playground-layout";
import { useTranslation } from "react-i18next";
export const Playground = ({
  singleRenderedChildren = false,
}: {
  singleRenderedChildren: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <DashboardLayout
      title={t("playground.aiChat")}
      fullHeight
      singleRenderedChildren={singleRenderedChildren}
    >
      <PlaygroundLayout singleRenderedChildren={singleRenderedChildren} />
    </DashboardLayout>
  );
};
